import { useMultiTierCheckout } from '../context';

const useCheckoutSummary = () => {
  const data = [];
  const {
    data: {
      event,
      checkoutSession: { checkoutSession }
    }
  } = useMultiTierCheckout();

  const eventPriceBreakdown = event?.pricing;
  const checkoutPriceBreakdown = checkoutSession?.pricing;
  const isHostPayingFees =
    eventPriceBreakdown?.transactionFeesPaidBy === 'host';

  if (checkoutPriceBreakdown?.discount) {
    data.push({
      subtitle: checkoutSession.discountCode?.code,
      title: 'Discount Code',
      value: -checkoutPriceBreakdown.discount
    });
  }

  if (eventPriceBreakdown?.tax) {
    data.push({
      subtitle: eventPriceBreakdown.tax?.name,
      title: 'Taxes',
      value: checkoutPriceBreakdown?.taxes
    });
  }

  data.push({
    subtitle: isHostPayingFees
      ? 'There are no fees for this ticket purchase'
      : 'Credit card processing fees',
    title: isHostPayingFees ? 'Fees' : 'Processing Fees',
    value: checkoutPriceBreakdown?.feesBreakdown.processingFees
  });

  if (!isHostPayingFees) {
    data.push({
      subtitle: '$1 per ticket service fee',
      title: 'Bounce Fees',
      value: checkoutPriceBreakdown?.feesBreakdown.bounceFees
    });
  }

  if (
    checkoutPriceBreakdown?.feesBreakdown.eventOrganizerFees &&
    checkoutPriceBreakdown?.feesBreakdown.eventOrganizerFees > 0
  ) {
    data.push({
      subtitle: 'Event Organizer Fee',
      title: 'Event Organizer Fees',
      value: checkoutPriceBreakdown.feesBreakdown.eventOrganizerFees
    });
  }

  return data;
};

export default useCheckoutSummary;
